import { array, boolean, defineAction, number, object, string } from '~/prix'
import any from '~/prix/types/any'
import preheatRecommendedItineraryCache from './preheatRecommendedItineraryCache.action.json'

const preheatRecommendedItineraryCacheDefinition = defineAction({
  ...preheatRecommendedItineraryCache,
  input: object({
    includeRecommended: boolean().isOptional(),
    includeSentinel: boolean().isOptional(),
    warmModel: boolean().isOptional(),
    warmUnattended: boolean().isOptional(),
    dryRun: boolean().isOptional(),
    recentDays: number().isOptional(),
    maxRecommendedTargets: number().isOptional(),
    maxSentinelTiles: number().isOptional(),
    maxSentinelSourcePoints: number().isOptional(),
    sleepSeconds: number().isOptional(),
    agentTargets: array(
      object({
        agentCpf: string(),
        longitude: number(),
        latitude: number(),
      }),
    ).isOptional(),
    sentinelTargets: array(
      object({
        longitude: number(),
        latitude: number(),
      }),
    ).isOptional(),
    sizes: array(string()).isOptional(),
    segments: array(string()).isOptional(),
    metadata: any().isOptional(),
  }),
  output: object({
    message: string(),
    dryRun: boolean(),
    recommended: any(),
    sentinel: any(),
    elapsedSeconds: number(),
  }),
})

export default preheatRecommendedItineraryCacheDefinition
